import { useState } from "react";
import { X } from "lucide-react";

const PHONE = "905454814275";

export default function WhatsAppButton() {
  const [tooltip, setTooltip] = useState(true);

  const url = `https://wa.me/${PHONE}?text=${encodeURIComponent("Merhaba, bilgi almak istiyorum.")}`;

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex items-end gap-3" data-testid="whatsapp-widget">
      {/* Tooltip */}
      {tooltip && (
        <div className="bg-white rounded-2xl shadow-xl px-4 py-3 max-w-[200px] relative animate-fade-in">
          <button
            onClick={(e) => { e.stopPropagation(); setTooltip(false); }}
            className="absolute -top-2 -right-2 w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors"
            data-testid="whatsapp-tooltip-close"
          >
            <X size={10} className="text-gray-600" />
          </button>
          <p className="text-xs text-gray-700 font-medium leading-relaxed">
            Merhaba! Size nasıl yardımcı olabiliriz?
          </p>
        </div>
      )}

      {/* Button */}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
        data-testid="whatsapp-button"
        aria-label="WhatsApp ile iletişime geçin"
      >
        <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.132 6.744 3.056 9.376L1.056 31.2l6.072-1.952A15.92 15.92 0 0016.004 32C24.828 32 32 24.824 32 16.004 32 7.176 24.828 0 16.004 0zm9.32 22.608c-.392 1.1-1.936 2.016-3.152 2.28-.832.18-1.916.324-5.568-1.196-4.672-1.944-7.684-6.696-7.92-7.004-.228-.308-1.86-2.48-1.86-4.732s1.176-3.356 1.592-3.816c.416-.46.908-.576 1.212-.576.304 0 .608.004.872.016.28.012.656-.108.028 1.6-.284.768-1.4 3.42-1.524 3.668-.124.248-.204.54-.044.86.168.328.248.528.496.816.248.288.52.644.744.864.248.248.504.52.864.716.36.196.656.12.912-.068.264-.188 1.1-1.288 1.4-1.728.288-.448.58-.368.968-.22.396.148 2.512 1.184 2.94 1.4.432.216.716.324.82.504.108.18.108 1.04-.284 2.14z"/>
        </svg>
      </a>
    </div>
  );
}
